module.exports = __webpack_public_path__ + "img/welcome-visual.26ae492.png";